import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent } from 'components/shadcn/ui/dialog';
import { Card } from 'components/shadcn/ui/card';
import { Button } from 'components/shadcn/ui/button';
import { updateWarranty } from 'components/DeviceDetails/EditDeviceProfile/service';
import { useJwtToken } from 'helper';

const WarrantyConfirmation = ({ warrantyData }) => {
    const accessToken = useJwtToken();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const confirmWarranty = async () => {
        setLoading(true);
        try {
            const { SerialNumber, deviceType, warrantyStartDate } =
                warrantyData;
            const newWarranty = {
                thingId: `BG_${SerialNumber}`,
                serialNumber: SerialNumber,
                type: deviceType,
                warrantyStartDate: warrantyStartDate,
                userConfirmation: true,
            };
            const updatedWarrantyResponse = await updateWarranty(
                newWarranty,
                warrantyData,
                accessToken
            );

            if (updatedWarrantyResponse) {
                setOpen(false);
            }
        } catch (error) {
            console.error('Error confirming warranty:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (warrantyData && !warrantyData?.userConfirmation) {
            setOpen(true);
        }
    }, [warrantyData]);

    return (
        <Dialog
            open={open}
            onOpenChange={setOpen}
            aria-labelledby="detach-site-confirmation-title"
            aria-describedby="detach-site-confirmation-description"
        >
            <DialogContent className="max-w-full sm:max-w-[650px]">
                <Card className="p-3 border-0 shadow-none">
                    <div className="flex flex-col gap-2">
                        <h1 className="text-4xl font-bold text-center mb-2">
                            Warranty Confirmation
                        </h1>
                        <p>
                            Your warranty start date for device{' '}
                            <strong>{warrantyData?.SerialNumber}</strong> is{' '}
                            <strong>{warrantyData?.warrantyStartDate}</strong> and
                            expires{' '}
                            <strong>{warrantyData?.warrantyExpirationDate}</strong>.
                        </p>
                        <p>Is this correct?</p>
                        <p>
                            If you believe the information above is incorrect,
                            please contact{' '}
                            <strong>support@lithionbattery.com</strong> with your
                            device serial number and the correct warranty start date
                            for it and we'll reach back out to you shortly.
                        </p>
                        <p>
                            By clicking the "Confirm" button, you agree to the terms
                            and conditions of the warranty:
                            <a
                                href="https://cdn.sanity.io/files/xcmp4e9i/production/7045f26ec3204934345a192e51555d8a2dfafac6.pdf"
                                className="ml-2"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <p className="inline font-bold hover:underline">
                                    USA
                                </p>
                            </a>
                            ,{' '}
                            <a
                                href="https://cdn.sanity.io/files/xcmp4e9i/production/8462073660844ce92d76c75eff0a033cf8cf0c27.pdf"
                                className="ml-2"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <p className="inline font-bold hover:underline">
                                    UK
                                </p>
                            </a>
                        </p>
                        <div className="mt-3 flex gap-2">
                            <Button
                                className="w-full"
                                onClick={confirmWarranty}
                            >
                                {loading ? (
                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white absolute opacity-100" />
                                ) : (
                                    'Confirm'
                                )}
                            </Button>
                            <Button
                                variant="outline"
                                onClick={() => setOpen(false)}
                                className="w-full"
                                disabled={loading}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </Card>
            </DialogContent>
        </Dialog>
    );
};

export default WarrantyConfirmation;
